import React from 'react';
import PropTypes from 'prop-types';
import ShortlistButton from '../../components/ShortlistButton/ShortlistButton';
import NoteButton from '../../components/NoteButton/NoteButton';
import HorseSireCell from '../../components/DataTable/HorseSireCell';

export default function CatalogueTableHorseCell({ shortlist, note, isExpanded, ...props }) {
    const content = <HorseSireCell {...props} />;

    if (isExpanded) return content;

    return (
        <div className="catalogueTable__horseCell">
            <div className="catalogueTable__horseCellContent">{content}</div>
            {shortlist && (
                <ShortlistButton
                    className="catalogueTable__horseCellIconButton"
                    highlighted
                />
            )}
            {note && (
                <NoteButton
                    className="catalogueTable__horseCellIconButton"
                    highlighted
                />
            )}
        </div>
    );
}

CatalogueTableHorseCell.propTypes = {
    isExpanded: PropTypes.bool,
    shortlist: PropTypes.bool,
    note: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/CatalogueTableHorseCell.js